module.exports = __webpack_public_path__ + "img/版图名.98f19a0b.svg";